/*
 * @Description:
 * @Author: kangkang
 * @Date: 2022-06-23 23:24:12
 * @LastEditTime: 2023-04-11 20:26:45
 * @LastEditors: kangkang
 * @Reference:
 */
/**
 * api 接口
 * @author: kinds
 * @create: 2017-11-20 14:35
 */
import Vue from "vue";
import axios from "axios";
import router from "../router";
import moment from 'moment';
import Store from '../store/index';
// toast
import { Toast } from 'vant';

Vue.use(Toast);
const _domain = process.env.VUE_APP_API_URL;

// 创建axios实例
const axiosInstance = axios.create({
    baseURL: _domain, //url
    headers: {
        //将被发送的自定义请求头
        // "Content-Type": "application/x-www-form-urlencoded"
    },
    withCredentials: true, //表示跨域请求时是否需要使用凭证
    timeout: 10000 //请求超时的毫秒数
});

// 添加请求拦截器
axiosInstance.interceptors.request.use(
    function(config) {
        // 在发送请求之前做些什么
        // if(sessionStorage.requestTime){
        //     let storageTime = sessionStorage.requestTime;
        //     let date = parseInt(moment(new Date()).valueOf() / 1000);
        //     let expiresIn = sessionStorage.expires_in;//规定token 过期时间
        //     let diff = date - storageTime * 1;//相差秒数
        //     if(expiresIn * 1 - diff < 1800){
        //         if(config.url.indexOf('getToken') == -1 && config.url.indexOf('refreshToken') == -1){
        //             Store.dispatch("doGetRefreshToken")
        //         }
        //     }
        // }
        // if(config.url.indexOf('getToken') == -1 && config.url.indexOf('refreshToken') == -1){
        //     console.log("ssss")
        //     Store.dispatch("doGetRefreshToken")
        // }
        let _token = sessionStorage.access_token;
        if(_token){
            if(config.url.indexOf('refreshToken') != -1){
                config.headers['authorization'] = 'Bearer '+ sessionStorage.refresh_token
            }else{
                config.headers['authorization'] = 'Bearer '+_token
            }

        }
        return config;
    },
    function(error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axiosInstance.interceptors.response.use(
    function(response) {
        // 对响应数据做点什么
        if (response.data.apiResultCode == 200) {
            return response.data.apiResultData;

        } else if(response.data.apiResultCode == 40018) {
            Store.dispatch("doGetRefreshToken");
            // 这一步逻辑，等时机掉接口的时候，再具体实施
            // Toast({
            //     mes: response.data.msg,
            //     duration: 2000,
            //     icon: 'error',
            //     callback: () => {
            //        //
            //     }
            // });
        }
        else if(response.data.apiResultCode == 40019) {
            router.replace({
                name:'error'
            })
        }
        else {
            if(response.data.apiErrorMsg){
                Toast(response.data.apiErrorMsg);
            }
        }
    },
    function(error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

export default axiosInstance;
export const domain = _domain;
